import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { physicsWorld, getRapier } from './physics.js';
import { rigidBodies } from './objects-shared.js';

export async function loadHelmetModel(scene) {
    const loader = new GLTFLoader();
    const RAPIER = getRapier();

    try {
        const gltf = await loader.loadAsync('https://threejs.org/examples/models/gltf/DamagedHelmet/glTF/DamagedHelmet.gltf');
        const helmet = gltf.scene;
        
        helmet.scale.set(15, 15, 15);
        const position = { x: 100, y: 30, z: -80 };
        helmet.position.set(position.x, position.y, position.z);
        
        helmet.traverse(child => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });
        
        scene.add(helmet);

        const bodyDesc = RAPIER.RigidBodyDesc.dynamic()
            .setTranslation(position.x, position.y, position.z)
            .setLinearDamping(0.5)
            .setAngularDamping(0.8)
            .setCanSleep(false);
        const body = physicsWorld.createRigidBody(bodyDesc);
        
        const boundingBox = new THREE.Box3().setFromObject(helmet);
        const size = boundingBox.getSize(new THREE.Vector3());
        const radius = Math.max(size.x, size.y, size.z) / 2;
        
        const colliderDesc = RAPIER.ColliderDesc.ball(radius)
            .setRestitution(0.5)
            .setFriction(0.3)
            .setDensity(1.5);
            
        physicsWorld.createCollider(colliderDesc, body);
        
        helmet.userData.physicsBody = body;
        rigidBodies.push(helmet);

    } catch (error) {
        console.error('An error happened while loading the helmet model:', error);
    }
}